var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIpDenim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 12l2-8h12l2 8v12l4 17l-12 3l-12-3l4-17zm8 32V16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 41l12 3l12-3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpDenim);
export default __webpack_public_path__ + "static/media/icon-ip-denim.e66005fdd57ac40fc97330218917fa8e.svg";
export { ForwardRef as ReactComponent };